<template>
    <div>
        ชำระเงินค่าขนส่งสินค้า
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>

</style>